<template>
  <div class="modal">
    <div
      class="modal_close"
      @click="close"/>
    <div
      v-if="searchMode !== 2 && formatList || (searchMode === 2 && geolocationFlg === -1 && formatList && formatList.length > 0)"
      class="modal__image">
      <h3>{{ modalTitle }}</h3>
      <slick
        ref="slick"
        :options="slickOptions"
        @beforeChange="handleBeforeChange"
        @afterChange="handleAfterChange">
        <img
          v-for="(item) in formatList"
          :key="'modal_image_' + item.museum_id"
          :src="setting.apiURL + 'museum/' + item.museum_id + '/image/image.jpg'">
      </slick>
      <p class="title">{{ formatList[nowSlide].museum_name }}</p>
      <p class="count">{{ (nowSlide + 1) + '/' + formatList.length }}</p>
    </div>
    <div
      v-else
      class="modal__msg">
      <span>{{ modalMsg }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/setting.js'
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
export default {
  name: 'Modal',
  components: {
    setting,
    mapGetters,
    Slick
  },
  computed: {
    ...mapGetters(['sliderFlg', 'museumList', 'searchMode', 'textData', 'lang', 'aroundLocation']),
    modalTitle: function () {
      // 0:デフォルト 1x:地域選択 2:位置情報
      if (this.searchMode >= 10) {
        let prefNum = Number(String(this.searchMode).slice(1, 2))
        return this.textData[this.lang.key].place['region' + prefNum]
      } else if (this.searchMode === 2) {
        return this.textData[this.lang.key].place.btn1
      } else {
        return this.textData[this.lang.key].place.btn2
      }
    },
    modalMsg: function () {
      // searchMode === 2の場合のみ表示
      if (this.searchMode === 2 && this.geolocationFlg !== null) {
        if (this.geolocationFlg === 1) {
          // 位置情報取得エラー
          return this.textData[this.lang.key].modal.error2
        } else {
          // 現在地近くに利用できる施設はありません
          return this.textData[this.lang.key].modal.error1
        }
      } else {
        return ''
      }
    },
    // リスト判定
    formatList: function () {
      let tmpAry = null
      // 0:デフォルト 1:地域選択 2:位置情報
      if (this.searchMode >= 10) {
        let prefNum = Number(String(this.searchMode).slice(1, 2))
        let tmp = this.museumList.filter(d => {
          return this.setting.prefecturesList[d.museum_pref] === prefNum
        })
        tmpAry = JSON.parse(JSON.stringify(tmp))
      } else if (this.searchMode === 2) {
        tmpAry = JSON.parse(JSON.stringify(this.formatByLocation))
      } else {
        tmpAry = JSON.parse(JSON.stringify(this.museumList))
      }
      console.log('formatList tmpAry:', tmpAry)
      // museum_pref + museum_idの昇順になるようにソート
      // mode = 2(位置情報)時はソートしない
      if (this.searchMode !== 2) {
        tmpAry.sort((a, b) => {
          const aNum = a.museum_pref + '_' + a.museum_id
          const bNum = b.museum_pref + '_' + b.museum_id
          if (aNum > bNum) return 1
          if (aNum < bNum) return -1
          return 0
        })
      }
      // デバッグ用 museum_pref + museum_id museum_nameをconsoleで表示
      tmpAry.forEach((item) => {
        console.log('sort:', item.museum_pref + '_' + item.museum_id + ' ' + item.museum_name + ' : ' + item.lat + ',' + item.lng)
      })
      // console.log('formatList:', JSON.stringify(tmpObj))
      return tmpAry
    },
    // 緯度経度でフィルタリング
    formatByLocation: function () {
      console.log('aroundLocation:', this.aroundLocation)
      let resAry = new Array(10)
      // 初期化
      for (let i = 0; i < resAry.length; i++) { resAry[i] = [] }
      this.museumList.forEach(d => {
        // 1km～10kmで最初に見つかった範囲のindexを返却
        let resIndex = this.aroundLocation.findIndex((item, index) => {
          return window.Number(d.lat) >= item[0][0] &&
            window.Number(d.lat) <= item[0][1] &&
            window.Number(d.lng) >= item[0][2] &&
            window.Number(d.lng) <= item[0][3]
        })
        console.log('check resIndex:', resIndex + ' : ' + d.museum_pref + '_' + d.museum_id + ' ' + d.museum_name + ' : ' + d.lat + ',' + d.lng)
        // resObjに1km～10kmでデータを割り振り
        if (resIndex !== -1) {
          resAry[resIndex].push(d)
        }
      })
      console.log('resAry1:', resAry)
      // 範囲ごとにmuseum_pref + museum_idの昇順になるようにソート
      // resAryに入っているデータを配列に連結する
      return resAry.map((tmpAry) => {
        return tmpAry.sort((a, b) => {
          const aNum = a.museum_pref + '_' + a.museum_id
          const bNum = b.museum_pref + '_' + b.museum_id
          if (aNum > bNum) return 1
          if (aNum < bNum) return -1
          return 0
        })
      }).reduce((a, b) => {
        return a.concat(b)
      }, [])
    }
  },
  data () {
    return {
      setting,
      slickOptions: {
        centerMode: true,
        centerPadding: '20%',
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="btn-prev">prev</button>',
        nextArrow: '<button type="button" class="btn-next">next</button>',
        swipeToSlide: true,
        responsive: [
          {
            breakpoint: 959,
            settings: {
              // centerMode: false,
              centerPadding: '0'
            }
          }
        ]
      },
      nowSlide: 0,
      geolocationFlg: null
    }
  },
  methods: {
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
      console.log('handleBeforeChange currentSlide', currentSlide)
      console.log(document.querySelector('.slick-active.slick-center').nextElementSibling.querySelector('img'))
      if (currentSlide === this.formatList.length - 1) {
        let element = document.querySelector('.slick-active.slick-center').nextElementSibling.querySelector('img')
        element.classList.add('list-border')
      }
    },
    handleAfterChange: function (event, slick, currentSlide) {
      console.log('handleAfterChange currentSlide', currentSlide)
      this.nowSlide = currentSlide
      let listBorder = document.querySelector('.list-border')
      if (listBorder) {
        listBorder.classList.remove('list-border')
      }
    },
    close: function () {
      this.$store.dispatch('resetSliderFlg')
    }
  },
  mounted () {
  },
  created () {
    if (this.$refs.slick && !this.$refs.slick.$el.classList.contains('slick-initialized')) {
      this.$refs.slick.create(this.slickOptions)
    }
    // 位置情報取得
    if (this.searchMode === 2) {
      this.$appGeolocation.getCurrentPosition()
        .then(res => {
          console.log('getCurrentPosition', res)
          this.$appGeolocation.getMinMaxCoords(res.coords.latitude, res.coords.longitude)
            .then(res => {
              console.log('getMinMaxCoords', res)
              this.$store.dispatch('setAroundLocation', { location: res })
              this.geolocationFlg = -1
            })
        })
        .catch(err => {
          console.log('位置情報を取得できませんでした。', err)
          this.geolocationFlg = err.code
        })
    }
  }
}
</script>

<style lang="postcss" scoped>
@import '../../assets/css/mixins.css';
@import '../../assets/css/variables.css';

  .modal {
    position: fixed;
    top: 0;
    z-index: 2000;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    &_close {
      position: absolute;
      z-index: 2500;
      top: 10px;
      left: 10px;
      width: 28px;
      height: 28px;
      padding: 5px;
      cursor: pointer;
    }
    &_close:before,
    &_close:after {
      content: '';
      position: absolute;
      left: 13px;
      height: 20px;
      width: 2px;
      background-color: #FFFFFF;
      border-radius: 1px;
    }
    &_close:before {
      transform: rotate(45deg);
    }
    &_close:after {
      transform: rotate(-45deg);
    }
    &__image {
      position: absolute;
      width: 100%;
      height: 80vh;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      color: #FFFFFF;
      & h3 {
        text-align: center;
        font-size: 40px;
        margin-bottom: 25px;
      }
      img {
        width: 40vw;
        height: 50vh;
        object-fit: contain;
        margin: auto;
      }
      & p {
        text-align: center;
      }
      & .title {
        font-size: 24px;
        line-height: 36px;
        font-weight: bold;
        width: 820px;
        margin: 10px auto 20px;
      }
      & .count {
        font-size: 30px;
      }
    }
    &__msg {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      padding: 20px;
      width: 100%;
      height: 100%;
      & span {
        text-align: center;
      }
    }
  }
  @media (--breakPoint) {
    .modal {
      &__image {
        width: 100%;
        & h3 {
          font-size: 20px;
          margin-bottom: 30px;
        }
        img {
          width: 80% !important;
          height: 45vh;
          margin: auto;
          display: block !important;
        }
        & .title {
          font-size: 18px;
          line-height: 26px;
          width: calc(100% - 40px);
          margin: 20px;
        }
        & .count {
          font-size: 16px;
        }
      }
    }
  }
  @media (--info-phoneSE) {
    .modal {
      &__image {
        img {
          height: 40vh;
        }
        & .title {
          font-size: 14px;
          line-height: 16px;
          margin: 15px;
        }
        & .count {
          font-size: 16px;
        }
      }
    }
  }
</style>
<style>
  .modal .slick-slide.slick-active {
    position: relative;
    z-index: 10000
  }
  .modal .slick-center img {
    opacity: 1;
  }
  .modal .btn-prev,
  .modal .btn-next {
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 25px;
    height: 50px;
    padding: 0;
    color: transparent;
    background: rgba(0, 0, 0, 0.8);
    z-index: 20;
    cursor: pointer;
  }
  .modal .btn-prev {
    left: 0;
    border-radius: 0 25px 25px 0;
  }
  .modal .btn-next {
    right: 0;
    border-radius: 25px 0 0 25px;
  }
  .modal .btn-prev::before,
  .modal .btn-next::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 12px;
    height: 12px;
  }
  .modal .btn-prev::before {
    left: 4px;
    background: url('../../assets/img/icon-previous.png');
    background-size: 12px;
  }
  .modal .btn-next::before {
    right: 4px;
    background: url('../../assets/img/icon-next.png');
    background-size: 12px;
    }
  @media (max-width: 959px) {
    .modal .slick-slide img {
      transition: unset;
      transform: none;
      opacity: 1;
    }
    .modal .slick-slide img.list-border {
      transition: unset;
      transform: none;
      opacity: 1;
    }
    .modal .slick-center img {
      transform: none;
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/Modal.vue